import { getICOContract } from "../utils/contractHelper";
import { ICO_ADDRESS } from "../config/constant";
import { ethers } from "ethers";
const usePresale = () => {
  const RpcProvider = new ethers.JsonRpcProvider(
    "https://goerli.infura.io/v3/9c48d1f781404552b1a017d597f6bee1"
  );
  const PresaleContract = getICOContract(ICO_ADDRESS, RpcProvider);

  const round = async () => {
    return await PresaleContract.round();
  };

  const preSaleRate = () => {
    return PresaleContract.preSaleRate();
  };

  const totalHardCap = () => {
    return PresaleContract.totalHardCap();
  };

  const ICOInfo = () => {
    return PresaleContract.ICOInfo();
  };

  const owner = () => {
    return PresaleContract.owner();
  };
  return {
    round,
    preSaleRate,
    totalHardCap,
    ICOInfo,

    owner,
  };
};

export default usePresale;
